/**
 * Site-wide accessibility fixes, September 2026.
 *
 * Everything here targets controls generated by scripts or by installed apps,
 * which therefore cannot be labelled in the theme's Liquid templates.
 * Anything that COULD be fixed at source was fixed at source instead --
 * see snippets/newsletter-popup.liquid, assets/a11y-enhancements.css, and the
 * product image alt text set in Shopify admin.
 */
(function () {
  'use strict';

  function titleFromHandle(href) {
    try {
      var handle = href.split('/products/')[1];
      if (!handle) return '';
      return handle.split('?')[0].split('-').join(' ').replace(/\b\w/g, function (c) {
        return c.toUpperCase();
      });
    } catch (e) { return ''; }
  }

  // Homepage testimonial images link to a product but contain no text, so a
  // screen reader announced an unlabelled link.
  function labelTestimonialLinks() {
    var links = document.querySelectorAll('a.testimonial__image-with-caption__link');
    Array.prototype.forEach.call(links, function (link) {
      if ((link.getAttribute('aria-label') || '').trim()) return;
      if ((link.textContent || '').trim()) return;

      var caption = link.parentElement &&
        link.parentElement.querySelector('.testimonial__caption, figcaption');
      var captionText = caption ? caption.textContent.trim() : '';
      var name = captionText || titleFromHandle(link.getAttribute('href') || '');
      if (!name) name = 'product';

      link.setAttribute('aria-label', 'Shop ' + name);
      var img = link.querySelector('img');
      if (img && !(img.getAttribute('alt') || '').trim()) {
        img.setAttribute('alt', name);
      }
    });
  }

  // The collection sort/filter <select> is injected by an app with no label.
  function labelFilterSelects() {
    var selects = document.querySelectorAll('select.cf-select, .cf-options-container select');
    Array.prototype.forEach.call(selects, function (sel) {
      if ((sel.getAttribute('aria-label') || '').trim()) return;
      if (sel.id && document.querySelector('label[for="' + sel.id + '"]')) return;
      sel.setAttribute('aria-label', 'Sort and filter products');
    });
  }

  // App-rendered form fields (the Acerill sizing form) use random GUIDs for
  // ids, and some fields have no associated label at all. Find the nearest
  // visible text that describes the field and tie the two together.
  function nearestLabelText(field) {
    var group = field.closest('.form-group') || field.parentElement;

    var labelEl = group && group.querySelector('label, .control-label, .form-label');
    if (labelEl && labelEl.textContent.trim()) return { el: labelEl, text: labelEl.textContent.trim() };

    // Walk backwards through preceding siblings looking for a caption.
    var node = group;
    while (node) {
      var prev = node.previousElementSibling;
      while (prev) {
        var text = (prev.textContent || '').replace(/\s+/g, ' ').trim();
        if (text && text.length <= 60 && !prev.querySelector('input, textarea, select')) {
          return { el: null, text: text };
        }
        prev = prev.previousElementSibling;
      }
      node = node.parentElement;
      if (node && node.classList && node.classList.contains('ace-cf-panel-body')) break;
    }
    return null;
  }

  function labelAppFormFields() {
    var fields = document.querySelectorAll(
      '.ace-cf-panel-body input, .ace-cf-panel-body textarea, .ace-cf-panel-body select'
    );
    Array.prototype.forEach.call(fields, function (field) {
      if (field.type === 'hidden') return;
      if ((field.getAttribute('aria-label') || '').trim()) return;
      if (field.id && document.querySelector('label[for="' + field.id + '"]')) return;

      var found = nearestLabelText(field);
      var text = found ? found.text : (field.getAttribute('placeholder') || '');
      if (!text) return;

      if (found && found.el && field.id) {
        found.el.setAttribute('for', field.id);
      } else {
        field.setAttribute('aria-label', text);
      }
    });
  }

  // App-injected images (e.g. video poster frames) sometimes ship with no alt
  // attribute at all, which screen readers read out as a filename. These are
  // decorative and sit next to their own text, so an empty alt is correct:
  // it tells assistive tech to skip them. Images inside links are left alone,
  // because there the alt text is the link's only name.
  function markDecorativeImages() {
    var imgs = document.querySelectorAll('img:not([alt])');
    Array.prototype.forEach.call(imgs, function (img) {
      if (img.closest('a') || img.closest('button')) return;
      img.setAttribute('alt', '');
    });
  }

  function run() {
    try { labelTestimonialLinks(); } catch (e) { /* never break the page */ }
    try { labelFilterSelects(); } catch (e) { /* never break the page */ }
    try { labelAppFormFields(); } catch (e) { /* never break the page */ }
    try { markDecorativeImages(); } catch (e) { /* never break the page */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Filters, app forms and lazy media render after load, so re-apply.
  var scheduled = null;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = window.setTimeout(function () { scheduled = null; run(); }, 250);
  }).observe(document.documentElement, { childList: true, subtree: true });
}());
